<mat-menu #menu="matMenu" class="pt-context-menu" (closed)="closed.emit()" [hasBackdrop]="false">
  <ng-container *ngFor="let item of visible(items)">
    <div class="pt-context-menu-separator" *ngIf="item.separator"></div>

    <ng-container *ngIf="!item.separator">
      <!-- pozycja z podmenu — rekurencyjny <app-context-submenu> -->
      <ng-container *ngIf="item.items?.length; else leaf">
        <span class="pt-context-menu-item-wrap" [matTooltip]="tipText(item)" [matTooltipPosition]="tipPos(item)"
          matTooltipClass="pt-context-menu-tooltip">
          <button mat-menu-item [matMenuTriggerFor]="sub.menu" [disabled]="item.disabled">
            <i *ngIf="item.icon" class="pt-context-menu-icon" [ngClass]="item.icon"></i>
            <span [innerHTML]="item.label"></span>
          </button>
        </span>
        <app-context-submenu #sub [items]="item.items"></app-context-submenu>
      </ng-container>

      <!-- pozycja-liść -->
      <ng-template #leaf>
        <span class="pt-context-menu-item-wrap" [matTooltip]="tipText(item)" [matTooltipPosition]="tipPos(item)"
          matTooltipClass="pt-context-menu-tooltip">
          <button mat-menu-item [disabled]="item.disabled" (click)="run(item)">
            <i *ngIf="item.icon" class="pt-context-menu-icon" [ngClass]="item.icon"></i>
            <span [innerHTML]="item.label"></span>
          </button>
        </span>
      </ng-template>
    </ng-container>
  </ng-container>
</mat-menu>
